var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3581 17.8515C13.2154 17.8515 13.083 17.8006 12.9607 17.6987L7 12.9301L1.0393 17.6987C0.835516 17.8617 0.611354 17.8923 0.366812 17.7904C0.122271 17.6681 0 17.4745 0 17.2096V0.641925C0 0.458519 0.0611353 0.305672 0.183406 0.183401C0.305677 0.061131 0.458515 0 0.641921 0H13.3581C13.5415 0 13.6943 0.061131 13.8166 0.183401C13.9389 0.305672 14 0.458519 14 0.641925V17.2096C14 17.393 13.9389 17.5458 13.8166 17.6681C13.6943 17.7904 13.5415 17.8515 13.3581 17.8515ZM7 11.4629C7.14265 11.4629 7.27511 11.5138 7.39738 11.6157L12.7467 15.8646V1.28385H1.28384V15.8646L6.60262 11.6157C6.72489 11.5138 6.85735 11.4629 7 11.4629Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.1bc129ccc19126f0f4613c347133cf9d.svg";
export { ForwardRef as ReactComponent };